<p-accordion [value]="0">
  <p-accordion-panel [value]="0">
    <p-accordion-header>Filtros</p-accordion-header>
    <p-accordion-content>
      <form method="POST" class="flex-wrap md:flex md:space-x-2 space-y-6 md:space-y-0 text-xs mt-2 align-middle"
            [formGroup]="form"
            (ngSubmit)="onSubmit()">

        <div [hidden]="hideTitle">
            <app-text-input [formGroup]="form" id="title" label="Nome/Titulo"></app-text-input>
        </div>

        <div [hidden]="hideCategory">
            <app-select-input
              [formGroup]="form"
              id="category"
              [options]="categories"
              placeholder="Categoria"
              label="Categoria"
              wrapperClass="mb-4">
            </app-select-input>
        </div>

        <div [hidden]="hideEventStatus">
            <app-select-input
              [formGroup]="form"
              id="eventStatus"
              [options]="eventStatuses"
              placeholder="Estado"
              label="Estado"
              wrapperClass="mb-4">
            </app-select-input>
        </div>

        <div [hidden]="hideEventDate">
            <app-calendar-input [formGroup]="form" id="eventDate" label="Data de Ocorrência" [maxDate]="eventMaxDate"></app-calendar-input>
        </div>

        <div [hidden]="hideProvince">
            <app-select-input
              [formGroup]="form"
              id="province"
              [options]="provinces"
              placeholder="Província"
              label="Província"
              wrapperClass="mb-4">
            </app-select-input>
        </div>

        <div class="grow hidden md:block"></div>

        <div class="flex space-x-2">
          <app-ae-button variant="plain" label="Limpar" size="sm" styleClass="text-xs"
            (buttonClick)="onClear()"></app-ae-button>
          <app-ae-button variant="primary" icon="pi pi-search" type="submit" label="Pesquisar"
            size="sm" styleClass="text-xs"></app-ae-button>
        </div>
      </form>
    </p-accordion-content>
  </p-accordion-panel>
</p-accordion>
